<ng-container *ngIf="!configData">
    <div class="row">
        <div class="col-lg-12 col-xl-10 offset-xl-1">


            <h3 class="mb-3">Product Types Supplied</h3>

            <div class="table-responsive">
                <table class="table table-condensed">
                    <thead>
                        <tr>
                            <th>Product type</th>
                            <th>Supplied?</th>
                            <!-- <th>Allow bespoke?</th> -->
                            <th>Configuration</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="underlined" *ngFor="let pt of productTypes">
                            <td class="col-5">{{pt.name}}</td>
                            <td>
                                <a (click)="toggleProductTypes(pt)">
                                    <i class="toggle fa"
                                        [ngClass]="{'fa-toggle-on text-success': productTypeSelected(pt.id) >= 0, 'fa-toggle-off' : productTypeSelected(pt.id) < 0}"></i>
                                </a>
                            </td>
                            <!-- <td>
                            <a *ngIf="productTypeSelected(pt.id) >= 0 && pt.allowBespoke" (click)="toggleProductTypeBespoke(pt)">
                                <i class="toggle fa"
                                   [ngClass]="{
                               'fa-toggle-on text-success': productTypeBespokeAllowed(pt.id),
                               'fa-toggle-off' : !productTypeBespokeAllowed(pt.id)
                               }"></i>
                            </a>
                        </td> -->
                            <td>
                                <a *ngIf="productTypeSelected(pt.id) >= 0" (click)="editProductType(pt)">
                                    <i class="fa fa-cog"></i>
                                </a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>


            <div class="row mt-3">
                <div class="col-6">
                </div>
                <div class="col-6 text-end">
                    <button type="button" (click)="continue()" class="btn btn-round btn-primary">
                        Continue
                    </button>
                </div>
            </div>
            <div class="mt-2 text-end">
                <p>Product types will be saved upon clicking 'Continue'</p>
            </div>

        </div>
    </div>
</ng-container>

<app-product-type-config [overlayData]="configData" (completed)="configData = undefined" *ngIf="configData">
</app-product-type-config>
